import React from 'react';
import '../privacy/PrivacyPolicy.css';
import LegalPage from '../../../components/LegalPage';
import PrivacyPolicyOwnerContent from '../../../content/legal/PrivacyPolicyOwnerContent';

const PrivacyPolicyOwner = () => (
  <LegalPage
    title="Privacy Policy - OW Owner"
    updated="20.09.2026"
    showHeroImage
  >
    <PrivacyPolicyOwnerContent />
  </LegalPage>
);

export default PrivacyPolicyOwner;
